module.exports = __webpack_public_path__ + "img/康熙题字.94575a1b.gif";